import { render, staticRenderFns } from "./ReporteCURP.vue?vue&type=template&id=8799d328&"
import script from "./ReporteCURP.vue?vue&type=script&lang=js&"
export * from "./ReporteCURP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports